import { MultiSelectOption } from 'components/forms/multiselect/MultiSelect';
import { Tag } from 'components/tag/Tag';

export type MultiSelectTagListProps = Readonly<{
    selectedOptions: MultiSelectOption<string>[];
    onChange: (selectedOptions: MultiSelectOption<string>[]) => void;
}>;

export function MultiSelectTagList({
    selectedOptions,
    onChange,
}: MultiSelectTagListProps) {
    return (
        <>
            {selectedOptions.length > 0 && (
                <div>
                    {selectedOptions.map((option) => (
                        <Tag
                            key={option.value}
                            unbordered
                            onDelete={() =>
                                onChange(
                                    selectedOptions.filter(
                                        (o) => o.value !== option.value,
                                    ),
                                )
                            }
                            deletable
                        >
                            {option.title}
                        </Tag>
                    ))}
                </div>
            )}
        </>
    );
}
